import { render, staticRenderFns } from "./FixturePropertiesPanel.vue?vue&type=template&id=5bab09d9&scoped=true&lang=pug&"
import script from "./FixturePropertiesPanel.vue?vue&type=script&lang=js&"
export * from "./FixturePropertiesPanel.vue?vue&type=script&lang=js&"
import style0 from "./FixturePropertiesPanel.vue?vue&type=style&index=0&id=5bab09d9&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bab09d9",
  null
  
)

/* custom blocks */
import block0 from "./FixturePropertiesPanel.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports